import { Heading } from "@amzn/meridian";
import { useEffect, useState } from "react";
import LoadingSpinner from "src/components/shared/loadingSpinner/loadingSpinner";
import { useAppDispatch, useAppSelector } from "src/store/store";
import ConversationsTable from "./components/conversationsTable";
import { getConversations } from "./store/adminSlice";

const ConversationList = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>();
  const conversations = useAppSelector(
    (state) => state.adminSlice.conversations,
  );

  const loadConversations = async () => {
    setIsLoading(true);
    try {
      await dispatch(getConversations());
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!conversations.length) loadConversations();
  }, [conversations]);

  return (
    <div>
      <Heading level={2}>Conversation List</Heading>
      {!isLoading ? <ConversationsTable /> : <LoadingSpinner />}
    </div>
  );
};

export default ConversationList;
